import { useEffect } from 'react'
import { Route, useLocation } from 'react-router-dom'

const RouteMiddleware = ({ path, component: Component, title, ...rest }) => {
  const location = useLocation()

  useEffect(() => {
    window.gtag('event', 'page_view', {
      page_title: title,
      page_path: location?.pathname + location?.search,
      page_location: window?.location?.href,
    })
  }, [location, title])

  return (
    <Route
      {...rest}
      path={path}
      render={(props) => <Component title={title} {...props} />}
    >
      {rest?.children}
    </Route>
  )
}

export default RouteMiddleware
